import React from 'react'
import styled from 'styled-components'
import Filename from './filename'
import { formatDate } from './utils'
import FileOptions from './file-options'

const UploadTimeElement = styled.p`
  font-size: 0.8rem;
  font-weight: 200;
  margin: 0;
`

const UploadedByElement = styled.p`
  font-size: 0.8rem;
  font-weight: 200;
  margin: 0;
`

const LastColumnWrapperElement = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

function FileRow({ file, documentId }) {
  const {
    name,
    trimmedFilename,
    isNew,
    archived,
    fileUrl,
    createdAt,
    uploadedBy = 'Unknown',
  } = file

  return (
    <>
      <Filename
        documentId={documentId}
        filename={name}
        originalFilename={trimmedFilename}
        fileUrl={fileUrl}
        isNew={isNew}
        archived={archived}
      />
      <UploadTimeElement>{formatDate(createdAt)}</UploadTimeElement>
      <LastColumnWrapperElement>
        <UploadedByElement>{uploadedBy}</UploadedByElement>
        <FileOptions file={file} documentId={documentId} />
      </LastColumnWrapperElement>
    </>
  )
}

export default FileRow
